import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "./ReactTable";
import { dispatch } from "@rematch/core";
import { debounce } from "lodash";
import { toastr } from "react-redux-toastr";
import LoadingComponent from "../../../common/LoadingComponent";
import ContentBreadCrum from "../Drive/breadcrumb/contentBreadcrum";
import AssignmentModal from "../Drive/Modal/AssignmentModal";
import moment from "moment";
const ContentList = ({
  contentListData,
  tableFilterQuery,
  routeParams,
  categoryTreeList,
  match,
  selectedAccount,
  ...props
}) => {
  const [listData, setListData] = useState([]);
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [usageContentOpen, setUsageContentOpen] = useState(false);
  const [filterState, setFilterState] = useState({
    selectedType: null,
    searchText: null,
    selectedBaseCategory:null,
    selectedCategory: null,
    selectedSubCategory:null, 
    selectedUser: null,
    selectedStatus:null,
    startDate:null,
    endDate:null,
    mixRange:null,
  });
  useEffect(() => {
    fetch = async () => {
      let query = {
        $skip: 0,
        $limit: 50,
        $sort: { createdAt: -1 },
      };
      await fetchData(query);
      if (!props.cancelFlag) {
        await dispatch.app.setTableFilterQuery(query);
        await dispatch.content.setBaseTableQuery(query);
      }  
      else {
        const existingFilters = tableFilterQuery.$and || [];
        console.log("Existing filters:", existingFilters);
        let newFilterState = {
          selectedType: null,
          searchText: null,
          selectedBaseCategory: null,
          selectedCategory: null,
          selectedSubCategory: null,
          selectedUser: null,
          selectedStatus: null,
          startDate: null,
          endDate: null,
          mixRange: null,
        };
  
        existingFilters.forEach(filter => {
          if (filter.type) {
            if (filter.type.$regex) {
              newFilterState.selectedType = filter.type.$regex;
            } else {
              newFilterState.selectedType = filter.type;
            }
          }
          if (filter.name && filter.name.$regex) {
            newFilterState.searchText = filter.name.$regex;
          }
          
          if (filter.baseCategory) {
            newFilterState.selectedBaseCategory = filter.baseCategory;
          }
          if (filter.category) {
            newFilterState.selectedCategory = filter.category;
          }
          if (filter.subCategory) {
            newFilterState.selectedSubCategory = filter.subCategory;
          }
          if (filter.status) {
            newFilterState.selectedStatus = filter.status;
          }
          if (filter.author) {
            newFilterState.selectedUser = filter.author;
          }
          if (filter.createdAt) {
            if (filter.createdAt.$gte) {
              newFilterState.startDate = moment(filter.createdAt.$gte)
                .startOf('day')
                .format("DD-MM-YYYY");
            }
            if (filter.createdAt.$lte) {
              newFilterState.endDate = moment(filter.createdAt.$lte)
                .endOf('day')
                .format("DD-MM-YYYY");
            }
            if (newFilterState.startDate && newFilterState.endDate) {
              newFilterState.mixRange = `${newFilterState.startDate} - ${newFilterState.endDate}`;
            }
          }
        });
  
        console.log("Setting new filter state:", newFilterState);
        setFilterState(newFilterState);
      }
  
      dispatch.content.setCancelFlag(false);
      // await dispatch.app.setTableFilterQuery(query);
      // await dispatch.content.setBaseTableQuery(query);
      let access =
        routeParams.status === "knowledgeBank"
          ? "Private"
          : routeParams.status === "publicKnowledgeBank"
          ? "Public"
          : "all";
      dispatch.categories.getCategoryTreeByAccess({
        accountId: match.params.accountId,
        access: access,
      });
      dispatch.account.setSelectedAccountDataForContentManagement({
        accountId: match.params.accountId,
        organizationId: match.params.organizationId,
      });
      let treeId = routeParams.subCategory ? routeParams.subCategory : routeParams.category ? routeParams.category : routeParams.baseCategory ? routeParams.baseCategory:  routeParams.status === "contentLibrary" 
      ? 1 : routeParams.status === "in_development"  ? 2 : routeParams.status === "published" ? 3  : routeParams.status === "approved" ? 7 
            : routeParams.status === "under_review" ? 4 : routeParams.status === "forreview" ? 5 : routeParams.status === "reviewRequest" ? 6 
                  : routeParams.status === "clonedorpurchased" ? 8 : !routeParams.status ? 1 : 9;
      dispatch.content.setSelectedTreeId(treeId);
      // setFilterState({
      //   selectedType: null,
      //   searchText: null,
      //   selectedBaseCategory:null,
      //   selectedCategory: null,
      //   selectedSubCategory:null, 
      //   selectedUser: null,
      //   selectedStatus:null,
      //   startDate:null,
      //   endDate:null,
      //   mixRange:null,
      // })
    };
    // if(props.contentComponentMounted){
      fetch();
    // }
    return ()=>{
      dispatch.content.setContentComponentMounted(false);
    }
  }, [props.contentComponentMounted, routeParams]);
  const fetchData = async (payloadQuery) => {
    let payload = {
      query: props.cancelFlag ? tableFilterQuery :payloadQuery ? payloadQuery : tableFilterQuery,
      params: { ...routeParams, status: match.params.status },
    };

    if (match.params.status === "publicKnowledgeBank") {
      payload.query.scope = "Public";
    }
    if(!payload.params.workspaceId) {
      payload.params.workspaceId = props.selectedOrganisation.id
    }
    try {
      setTimeout(async () => {
        if (!props.contentLoading) {
          await dispatch.content.getContentListData(payload);
        }
      }, 100);
    } catch (error) {
      console.error("Error fetching content list data:", error);
    }
  };
  useEffect(() => {
    const fetch = () => {
      if (contentListData && contentListData.data) {
        disabledMenus(contentListData);
        setListData(contentListData.data);
        setTotalRecords(contentListData.total);
      }
    };
    fetch();
  }, [contentListData]);
  useEffect(() => {
    const fetch = () => {
      if ((match.params.status && match.params.status !== routeParams.status) || (!match.params.status && routeParams.status)) {
        dispatch.app.setRouteParams(match.params);
      }

      if (match.params.status) {
        let rp = routeParams;
        let np = match.params;
        if (
          rp.status !== np.status ||
          rp.baseCategory !== np.baseCategory ||
          rp.category !== np.category ||
          rp.subCategory !== np.subCategory
        ) {
          dispatch.app.setRouteParams(match.params);
        }
      }
    };
    fetch();
  }, [match]);
  const handleHeaderClick = async (id) => {
    setSortColumn(id);
    if (id === "baseCategory") {
      id = "baseCategory.name";
    } else if (id === "category") {
      id = "category.name";
    } else if (id === "subCategory") {
      id = "subCategory.name";
    }
    let query = { ...tableFilterQuery };
    if (query.$sort[id] === 1) {
      delete query.$sort;
      setSortOrder(false);
      query.$sort = { [id]: -1 };
    } else if (query.$sort[id] === -1) {
      delete query.$sort;
      setSortOrder(true);
      query.$sort = { [id]: 1 };
    } else {
      delete query.$sort;
      setSortOrder(true);
      query.$sort = { [id]: 1 };
    }
    dispatch.app.setTableFilterQuery(query);
    dispatch.content.setBaseTableQuery(query)
    fetchData(query);
  };
  const handlePagination = (skip, limit) => {
    let query = { ...tableFilterQuery };
    query.$skip = skip;
    query.$limit = limit;
    dispatch.app.setTableFilterQuery(query);
    dispatch.content.setBaseTableQuery(query)
    fetchData(query);
  };
  const handleNameFilter = debounce((id, name) => {
    let query = { ...tableFilterQuery };
    if(query.$and && query.$and.length > 0 && query.$and.some(query=>query[id])){
      query.$and.map((query)=>{
        if (query[id]){
        query[id] = { $regex: name, $options: "i" }
        }
       })
    }else {
      query.$and = query.$and && query.$and.length > 0 ? [...query.$and,{ [id]: { $regex: name, $options: "i" } }]:[{ [id]: { $regex: name, $options: "i" } }]; 
    }
    query.$skip = 0;
    dispatch.app.setTableFilterQuery(query);
    dispatch.content.setBaseTableQuery(query)
    fetchData(query);
  }, 700);
  const handleDropdownFilter = (id, objId) => {
    let query = { ...tableFilterQuery };
    if(id === 'createdAt' && !objId && query.$and && query.$and.length > 0 && query.$and.some((query)=>query.createdAt)){
      query.$and.map((query)=>{
       if (query.createdAt){
       delete query.createdAt
       }
      })
    } else if(id === 'updatedAt' && !objId && query.$and && query.$and.length > 0 && query.$and.some((query)=>query.updatedAt)){
      query.$and.map((query)=>{
       if (query.updatedAt){
       delete query.updatedAt
       }
      })
    } else if(query.$and && query.$and.length > 0 && query.$and.some(query=>query[id])){
      query.$and.map((query)=>{
        if (query[id]){
        query[id] = objId
        }
       })
    }else {
      query.$and = query.$and && query.$and.length > 0 ? [...query.$and,{ [id]: objId }]:[{ [id]: objId }]; 
    }
    query.$skip = 0;
    const uniqueObjects = new Map();
    if(query.$and && query.$and.length > 0 ){
      query.$and.forEach(obj => {
        if (Object.keys(obj).length !== 0) {
            uniqueObjects.set(JSON.stringify(obj), obj);
        }
      });
      query.$and = Array.from(uniqueObjects.values());
    }
    dispatch.app.setTableFilterQuery(query);
    dispatch.content.setBaseTableQuery(query)
    fetchData(query);
  };
  const goToLink = (event, data) => {
    let redirectUrl =
      data.contentpath.indexOf("://") === -1
        ? "http://" + data.contentpath
        : data.contentpath;
    window.open(redirectUrl, "_blank");
  };
  const handleResetFilters = async () => {
    const query = {
      $skip: 0,
      $limit: 50,
      $sort: { createdAt: -1 },
    };

    await fetchData(query);
    await dispatch.app.setTableFilterQuery(query);
    await dispatch.content.setBaseTableQuery(query);
  }
  const editContents = (content) => {
    // dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    // dispatch.content.openResourcePane(null);

    const history = props.history;
    let status = content.status;
    if (status === "in_development") {
      status = "in_development";
    }

    dispatch.content.showAddContentBreadCrum(true);
    dispatch.content.setEditContentPage(true);
    dispatch.content.authorizeBreadcrum(false);
    history.push({
      pathname: `/app/${match.params.accountId}/_ws/${match.params.workspaceId}/_ct/edit/${status}/${content._id}`,
    });
  };
  const authorizeContent = (content) => {
    const history = props.history;
    let status = content.status;
    if (status === "under_review") {
      status = "under_review";
    }
    dispatch.content.setEditContent(content);
    dispatch.content.setEditContentPage(true);
    history.push({
      pathname: `/app/${match.params.accountId}/_ws/${match.params.workspaceId}/_ct/edit/${status}/${content._id}`,
    });
    dispatch.content.showAddContentBreadCrum(true);
    dispatch.content.authorizeBreadcrum(true);
  };
  const deleteContent = async (content, event) => {
    try {
      event.stopPropagation();
      // await dispatch.content.checkContentBeforeDelete(content._id);
      let payload = content;

      let message = (
        <div className="confirmMessage">
          <h3>Delete Content</h3>
          <label>{payload.name}</label>
          <p>Are you sure that you wish to do this?</p>
          <span>This action is not reversible</span>
        </div>
      );
      toastr.confirm(message, {
        onOk: async () => {
          payload.status = "inactive";
          payload.contentStatus = match.params.status
            ? match.params.status
            : "";
          payload.currentContentStatus = match.params.status;
          await dispatch.content.deleteContents(payload);
          await fetchData();
          setSortOrder(true);
          setSortColumn("");
        },
      });
    } catch (err) {
      const toastrConfirmOptions = {
        disableCancel: true,
      };
      toastr.confirm(err.message, toastrConfirmOptions, {
        onOk: () => {},
      });
    }
  };
  const selectContent = async (e, data) => {
    e.stopPropagation();
    await dispatch.content.setSelectedContent(data);
    await dispatch.content.splitAt("60%");
    await dispatch.content.openResourcePane("ContentDetail");
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
  };

  const copyContent = async (e, content) => {
    await dispatch.content.copyContent(content);
    await fetchData();
  };
  const openUsageContentModal = (open) => {
    setUsageContentOpen(open);
  };

  const usagesContent = async (e, content) => {
    content.id = content._id;
    await dispatch.content.setSingleContent(content);
    openUsageContentModal(true);
  };
  const disabledMenus = async (allContent) => {
    if (allContent && allContent.data) {
      for (let i = 0; i < allContent.data.length; i++) {
        let d = allContent.data[i];
        // Disabled Button If user not to delete access
        if (
          (d.author === props.user._id ||
            props.selectedOrganisation.role === "workspaceOwner") &&
          d.organizationId.toString() ===
            props.selectedOrganisation.id.toString()
        ) {
          d.isDeleteAccess = false;
        } else {
          d.isDeleteAccess = true;
        }

        // Disabled Button If user not to Edit access

        if (
          (d.status === "in_development" ||
            d.status === "rejected" ||
            props.contentStatus !== "forreview" ||
            d.status === "published") &&
          d.status !== "under_review" &&
          (d.author === props.user._id ||
            props.selectedOrganisation.role === "workspaceOwner") &&
          d.organizationId.toString() ===
            props.selectedOrganisation.id.toString()
        ) {
          d.isEditAccess = false;
        } else {
          d.isEditAccess = true;
        }

        // Disabled Button If user not to Review access

        if (
          ((d.status === "under_review" && d.reviewedby === props.user._id) ||
            (props.contentStatus === "forreview" &&
              d.reviewedby === props.user._id)) &&
          d.organizationId.toString() ===
            props.selectedOrganisation.id.toString()
        ) {
          d.isReviewAccess = false;
        } else {
          d.isReviewAccess = true;
        }

        // Disabled Button If user not to Review access

        if (
          d.scope === "Private" &&
          d.status === "published" &&
          d.organizationId.toString() ===
            props.selectedOrganisation.id.toString()
        ) {
          d.isUsageViewAccess = false;
        } else {
          d.isUsageViewAccess = true;
        }
      }
    }
  };
  const handleDropdownActions = async (event, type, data) => {
    event.stopPropagation();
    await dispatch.content.openResourcePane(null);

    if (type.text === "Link") {
      goToLink(event, data);
    }
    if (type.text === "Edit") {
      editContents(data);
    }
    if (type.text === "Delete") {
      deleteContent(data, event);
    }
    if (type.text === "Review") {
      authorizeContent(data);
    }
    if (type.text === "View") {
      selectContent(event, data);
    }
    if (type.text === "Copy") {
      copyContent(event, data);
    }
    if (type.text === "Usage") {
      usagesContent(event, data);
    }
  };

  return (
    <div>
      <div style={{ marginTop: "20px", marginLeft: "15px" }}>
        <ContentBreadCrum {...props} routeParams={routeParams} match={match} />
      </div>
      <div style={{ padding: "10px" }}>
        <ReactTable
          data={listData}
          totalRecords={totalRecords}
          tableFilterQuery={tableFilterQuery}
          handleHeaderClick={handleHeaderClick}
          handlePagination={handlePagination}
          handleResetFilters={handleResetFilters}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          filterState={filterState}
          setFilterState={setFilterState}
          handleNameFilter={handleNameFilter}
          selectedAccount={selectedAccount}
          handleDropdownFilter={handleDropdownFilter}
          categoryList={props.categoryList}
          categoryTreeList={categoryTreeList}
          routeParams={routeParams}
          handleDropdownActions={handleDropdownActions}
          {...props}
        />
      </div>
      <LoadingComponent
        active={props.contentLoading}
        message={"Fetching Contents..."}
      />
      <LoadingComponent active={props.importContentLoader || props.exportContentLoader} message={props.exportContentLoader ? "Exporting Content":"Importing Content"} />
      {usageContentOpen ? (
        <AssignmentModal
          open={usageContentOpen}
          selectedContent={props.selectedContent}
          openUsageContentModal={openUsageContentModal}
        />
      ) : null}
    </div>
  );
};

export default withRouter(ContentList);
